'use client'

import { SolidButton, Text } from '@macarongfactory/web-ui'

import { OptimizedImage } from '@/shared/ui'

import shareIllust from '../_assets/share-illust.png'
import {
  buildCtaSubtext,
  HOME_APP_ONELINK_URL,
  HOME_COPY,
  HOME_TRACK_CODE,
  HOME_TRACK_LABEL,
  HOME_TRACK_TYPE,
  MOCK_REVIEW_CAR_COUNT,
  useHomeImpression,
  useHomeTracking,
} from '../_features/modoocar-home'

const CTA_BACKGROUND = '#1A2128'

const HomeAppCta = () => {
  const { sectionShow, itemClick } = useHomeTracking()

  const sectionRef = useHomeImpression<HTMLElement>(() =>
    sectionShow(HOME_TRACK_CODE.APP_DOWNLOAD, HOME_TRACK_LABEL.APP_SECTION)
  )

  const handleClick = () => {
    itemClick(
      HOME_TRACK_CODE.APP_DOWNLOAD,
      HOME_TRACK_TYPE.BUTTON,
      HOME_TRACK_LABEL.APP_BUTTON
    )
    window.open(HOME_APP_ONELINK_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <section
      ref={sectionRef}
      className='flex flex-col items-center gap-dimension-x6 px-dimension-x5 py-dimension-x10'
      style={{ backgroundColor: CTA_BACKGROUND }}
    >
      <div className='flex flex-col items-center gap-dimension-x2-5 text-center'>
        <p className='text-heading-1-bold text-foreground-static-white'>
          <span className='block'>{HOME_COPY.ctaTitle1}</span>
          <span className='block'>{HOME_COPY.ctaTitle2}</span>
        </p>
        <Text
          variant='title-2-medium'
          color='text-foreground-neutral-assistive'
        >
          {buildCtaSubtext(MOCK_REVIEW_CAR_COUNT)}
        </Text>
      </div>

      <div className='flex w-full flex-col items-center'>
        <OptimizedImage
          src={shareIllust}
          alt=''
          width={120}
          height={102}
          radius={0}
          sizes='120px'
        />
        <SolidButton
          text={HOME_COPY.ctaButton}
          variant='brand'
          size='large'
          fullWidth
          clickable={handleClick}
        />
      </div>
    </section>
  )
}

export default HomeAppCta
